import { GET_LANGUAGE_SUCCESS } from "./actionTypes";
import { LocalizationActionTypes } from "./types";

const initialState = {
  locale: "cs",
};

export default (state = initialState, action: LocalizationActionTypes) => {
  switch (action.type) {
    case GET_LANGUAGE_SUCCESS:
      return { locale: action.item };
    default:
      return state;
  }
};
